export default __webpack_public_path__ + "static/media/speedkino_banner_highlight.02e3be9e.png";